export default "__VITE_ASSET__c82ca64f__"